import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Form } from 'react-redux-form';
import { Row, Col } from 'react-bootstrap';
import Translation from "../../../../common/translation/translation.component";
import { TRANSLATIONS as translation } from '../../../../../utils/constant.utils';
import { validateEmail } from '../../../../../utils/validation.utils';
import {
    ORFButton
    , ORFDatePicker
    , OR_RRF_TextArea as TextArea
    , OR_RRF_InputField as InputField
    , OR_RRF_Select as Select
    , ORFSearchSuggestions as SearchSuggestions
} from '../../../../common/forms/order-request-form.component';
import { wirelineChangeVendorActions } from "./../../../../../store/external/request-reducer/order-request-reducer/wireline-request/wireline-change-vendor.reducer";
import { createRequestActions } from "./../../../../../store/external/request-reducer/create-request.reducer";
import { requestLogActions } from "./../../../../../store/external/request-reducer/request-log.reducer";
import { fileAttachmentActions } from "./../../../../../store/external/common-reducer/file-attachment.reducer";
import FileAttachment from '../../../../common/file-attachment/file-attachment.component';
import { trueFalseToBoolean } from '../../../../../utils/helpers.utils';
import Icons from '../../../../icon';

class WirelineChangeVendorForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            needByDate: '',
            localToggle: false,
            alterToggle: false,
        }
    }

    componentWillUnmount() {
        this.props.resetWirelineChangeVendorForm();
        this.props.resetRequestData();
        this.props.resetFileAttachment();
    }

    submitRequest = async () => {
        const { submitRequest, modalMessage, fetchRequestLogItems
            , uploadFile, saveOrderFile} = this.props;

        var success = await submitRequest(this.state.needByDate);
        if (success.Success) {
            var res = await uploadFile(success.OrderId);
            if (res != null && res.Result) {
                saveOrderFile(success.OrderId, res.FileNames);
            }

            fetchRequestLogItems(0);
        }
        modalMessage(success);
    }

    onClickCancel = () => {
        const { modalClose } = this.props;

        if (modalClose) {
            modalClose();
        }
    }

    setNeedByDate = (v) => {
        this.setState({
            needByDate: v
        });
    }

    toggleLocalContainer() {
        this.setState({ localToggle: !this.state.localToggle })
    }

    toggleAlterContainer() {
        this.setState({ alterToggle: !this.state.alterToggle })
    }

    toLocaleLanguage = (key) => {
        const { locale } = this.props;
        if (locale === null || locale === '')
            return translation[translation['defaultLocaleLanguage']][key];

        return translation[locale][key];
    }

    render() {
        const {
            //form
            wirelineChangeVendorFormA
            //reducer action
            , onSubscriptionSelect
            , onEmployeeSelect
            , fetchSubscriptionByValue
            , fetchEmployeeByValue
            , onVendorSelect
            , onChangeExpedite
        } = this.props;

        const { subscriptionList, employeeList, takeActionCircuitCode } = this.props.createRequest;
        const { preferredVendorOptions, accountOptions, formSubmitted, subscription } = this.props.wirelineChangeVendorRequest;
        const { needByDate } = this.state;

        let minDate = new Date();
        minDate.setDate(minDate.getDate() + 1);

        let expediteOptions = [
            {
                "Key": true,
                "Value": "Yes"
            },
            {
                "Key": false,
                "Value": "No"
            }
        ];

        return (
            <div>
                <Form method="post" role="form"
                    model="wirelineChangeVendorFormA"
                    onSubmit={this.submitRequest}
                >
                    <Row>
                        <Col xs={12} md={12} lg={12}>
                            <SearchSuggestions
                                value={wirelineChangeVendorFormA.circuitCode}
                                label={`${this.toLocaleLanguage('subscription_number')} *`}
                                propDisplay={'CircuitCode'}
                                options={subscriptionList.length > 0 ? subscriptionList : ''}
                                onChangeAction={onSubscriptionSelect}
                                searchAction={fetchSubscriptionByValue}
                                defaultValue={takeActionCircuitCode}
                            />
                            {wirelineChangeVendorFormA.circuitCode != '' &&
                                <div className="pb-15-pl-30">
                                {subscription.PlanName} <span>&#8226;</span> {subscription.VendorName} <span>&#8226;</span> {subscription.SimName}
                                </div>
                            }
                        </Col>
                    </Row>
                    <span className='text-field-title'><Translation translationKey="change_to_reqular" /></span>
                    <Row>
                        <Col xs={12} md={12} lg={12}>
                            <Select
                                className="form-control"
                                label={`${this.toLocaleLanguage('vendor')} *`}
                                value={wirelineChangeVendorFormA.vendorDetailId}
                                options={preferredVendorOptions}
                                placeholder={this.toLocaleLanguage('select_a_vendor')}
                                fieldProp='.vendorDetailId'
                                onChangeAction={onVendorSelect}
                                disabled={wirelineChangeVendorFormA.circuitId == 0}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={12} md={12} lg={12}>
                            <Select
                                className="form-control"
                                label={`${this.toLocaleLanguage('account')} *`}
                                value={wirelineChangeVendorFormA.financeAccountId}
                                options={accountOptions}
                                placeholder={this.toLocaleLanguage('select_an_account')}
                                fieldProp='.financeAccountId'
                                disabled={wirelineChangeVendorFormA.circuitId == 0
                                    || wirelineChangeVendorFormA.vendorDetailId == 0}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={12} md={12} lg={12}>
                            <SearchSuggestions
                                value={wirelineChangeVendorFormA.employeeEmail}
                                label={`${this.toLocaleLanguage('approver')} *`}
                                propDisplay={'Name'}
                                options={employeeList.length > 0 ? employeeList : ''}
                                onChangeAction={onEmployeeSelect}
                                searchAction={fetchEmployeeByValue}
                                disabled={wirelineChangeVendorFormA.circuitId == 0}
                            />
                        </Col>
                    </Row>
                    <div className="local-contact-container" onClick={this.toggleLocalContainer.bind(this)}>
                        <Icons
                            customClassName="icon-circle-plus"
                            name={this.state.localToggle ? `circle-minus-reg` : `circle-plus-reg`}
                            size="20px"
                            containerClass="icon-circle-plus-container"
                        />
                        <h1 className="local-contact-header"><Translation translationKey="local_contact_title" /></h1>
                    </div>
                    {this.state.localToggle ?
                        <div className="local-list-container">
                            <Row>
                                <Col xs={12} md={12} lg={12}>
                                    <InputField
                                        className="form-control"
                                        type="text"
                                        label={`${this.toLocaleLanguage('local_contact_email_address')} *`}
                                        value={wirelineChangeVendorFormA.localContactEmail}
                                        fieldProp='.localContactEmail'
                                        disabled={wirelineChangeVendorFormA.circuitId == 0}
                                    />
                                </Col>
                            </Row>
                            <Row>
                                <Col xs={12} md={12} lg={12}>
                                    <InputField
                                        className="form-control"
                                        type="text"
                                        label={`${this.toLocaleLanguage('local_contact_fullname')} *`}
                                        value={wirelineChangeVendorFormA.localContactFullName}
                                        fieldProp='.localContactFullName'
                                        disabled={wirelineChangeVendorFormA.circuitId == 0}
                                    />
                                </Col>
                            </Row>
                            <Row>
                                <Col xs={12} md={12} lg={12}>
                                    <InputField
                                        className="form-control"
                                        type="text"
                                        label={`${this.toLocaleLanguage('local_contact_phone_number')} *`}
                                        value={wirelineChangeVendorFormA.localContactPhone}
                                        fieldProp='.localContactPhone'
                                        disabled={wirelineChangeVendorFormA.circuitId == 0}
                                    />
                                </Col>
                            </Row>
                        </div>
                        : ""}
                    <div className="local-contact-container" onClick={this.toggleAlterContainer.bind(this)}>
                        <Icons
                            customClassName="icon-circle-plus"
                            name={this.state.alterToggle ? `circle-minus-reg` : `circle-plus-reg`}
                            size="20px"
                            containerClass="icon-circle-plus-container"
                        />
                        <h1 className="local-contact-header"><Translation translationKey="alt_local_contact_title" /></h1>
                    </div>
                    {this.state.alterToggle ?
                        <div className="alter-list-container">
                            <Row>
                                <Col xs={12} md={12} lg={12}>
                                    <InputField
                                        className="form-control"
                                        type="text"
                                        label={`${this.toLocaleLanguage('alt_local_contact_email_address')} *`}
                                        value={wirelineChangeVendorFormA.altLocalContactEmail}
                                        fieldProp='.altLocalContactEmail'
                                        disabled={wirelineChangeVendorFormA.circuitId == 0}
                                    />
                                </Col>
                            </Row>
                            <Row>
                                <Col xs={12} md={12} lg={12}>
                                    <InputField
                                        className="form-control"
                                        type="text"
                                        label={`${this.toLocaleLanguage('alt_local_contact_full_name')} *`}
                                        value={wirelineChangeVendorFormA.altLocalContactFullName}
                                        fieldProp='.altLocalContactFullName'
                                        disabled={wirelineChangeVendorFormA.circuitId == 0}
                                    />
                                </Col>
                            </Row>
                            <Row>
                                <Col xs={12} md={12} lg={12}>
                                    <InputField
                                        className="form-control"
                                        type="text"
                                        label={`${this.toLocaleLanguage('alt_local_contact_phone_number')} *`}
                                        value={wirelineChangeVendorFormA.altLocalContactPhone}
                                        fieldProp='.altLocalContactPhone'
                                        disabled={wirelineChangeVendorFormA.circuitId == 0}
                                    />
                                </Col>
                            </Row>
                        </div>

                        : ""}
                    <Row>
                        <Col xs={12} md={12} lg={12}>
                            <ORFDatePicker
                                label={`${this.toLocaleLanguage('need_by_date')} *`}
                                value={needByDate}
                                action={this.setNeedByDate}
                                disabled={wirelineChangeVendorFormA.circuitId == 0}
                                minDate={minDate}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={12} md={12} lg={12}>
                            <Select
                                className="form-control"
                                label={`${this.toLocaleLanguage('expedite_request')} *`}
                                value={wirelineChangeVendorFormA.expediteRequest}
                                onChangeAction={onChangeExpedite}
                                options={expediteOptions}
                                fieldProp='.expediteRequest'
                                disabled={wirelineChangeVendorFormA.circuitId == 0}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={12} md={12} lg={12}>
                            <TextArea
                                label={`${this.toLocaleLanguage('business_justification')} *`}
                                fieldProp='.businessJustification'
                                value={wirelineChangeVendorFormA.businessJustification}
                                disabled={wirelineChangeVendorFormA.circuitId == 0 || !trueFalseToBoolean(wirelineChangeVendorFormA.expediteRequest)}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={12} md={12} lg={12}>
                            <TextArea
                                label={this.toLocaleLanguage('additional_information')}
                                fieldProp='.additionalInformation'
                                value={wirelineChangeVendorFormA.additionalInformation}
                                disabled={wirelineChangeVendorFormA.circuitId == 0}
                            />
                        </Col>
                    </Row>
                    <FileAttachment />
                    <div className="request-button-continer">
                        <div className="bottom-left">
                            <ORFButton
                                label={this.toLocaleLanguage('modal_close_cancel_button')}
                                variant={"light"}
                                action={this.onClickCancel}
                                type="button"
                            />
                        </div>
                        <div className="bottom-right">
                            <div>
                                <ORFButton
                                    label={this.toLocaleLanguage('submit_request_button')}
                                    variant={"primary"}
                                    type="submit"
                                    disabled={wirelineChangeVendorFormA.circuitId == 0
                                        || wirelineChangeVendorFormA.vendorDetailId == 0
                                        || wirelineChangeVendorFormA.financeAccountId == 0
                                        || wirelineChangeVendorFormA.wireLineApproverId == 0

                                        || wirelineChangeVendorFormA.localContactEmail == ''
                                        || !validateEmail(wirelineChangeVendorFormA.localContactEmail)
                                        || wirelineChangeVendorFormA.localContactFullName == ''
                                        || wirelineChangeVendorFormA.localContactPhone == ''

                                        || wirelineChangeVendorFormA.altLocalContactEmail == ''
                                        || !validateEmail(wirelineChangeVendorFormA.altLocalContactEmail)
                                        || wirelineChangeVendorFormA.altLocalContactFullName == ''
                                        || wirelineChangeVendorFormA.altLocalContactPhone == ''

                                        || needByDate == ''
                                        || (trueFalseToBoolean(wirelineChangeVendorFormA.expediteRequest) && wirelineChangeVendorFormA.businessJustification == '')
                                        || formSubmitted}
                                />
                            </div>
                        </div>
                    </div>
                </Form>
            </div>
        );
    }
};

export default connect(
    state => {
        const { wirelineChangeVendorRequest, createRequest, translation } = state;
        const { wirelineChangeVendorFormA } = state.form;
        return {
            wirelineChangeVendorRequest
            , wirelineChangeVendorFormA
            , createRequest
            , ...translation
        };
    }
    , dispatch =>
        bindActionCreators(
            Object.assign({}, wirelineChangeVendorActions
                , createRequestActions
                , requestLogActions
                , fileAttachmentActions
            ),
            dispatch
        )
)(WirelineChangeVendorForm);